import { FC } from "react";
import FavoritesList from "./favorites-list";
import EmptyFavoritesList from "./empty-favorites-list";

interface IFavoritesContent {
  count: number;
}

const FavoritesContent: FC<IFavoritesContent> = ({ count }) => {
  return count ? <FavoritesList /> : <EmptyFavoritesList />;
};

export default FavoritesContent;
